import { doc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

// Default admin emails for each environment
const DEFAULT_ADMIN_EMAILS = [
  'admin@strategiz.io',
  'test@gmail.com',
  'test1@gmail.com',
  'test2@gmail.com'
];

/**
 * Initialize admin emails in Firestore
 * This function should be called once to set up the initial admin emails for all environments
 * @param globalEmails List of admin emails for all environments
 * @param devEmails List of admin emails for development environment
 * @param prodEmails List of admin emails for production environment
 */
export async function initializeAdminEmails({
  globalEmails = DEFAULT_ADMIN_EMAILS,
  devEmails = DEFAULT_ADMIN_EMAILS,
  prodEmails = DEFAULT_ADMIN_EMAILS
}: {
  globalEmails?: string[];
  devEmails?: string[];
  prodEmails?: string[];
} = {}) {
  try {
    // Validate email lists
    if (globalEmails.length === 0) {
      throw new Error('At least one global admin email is required');
    }
    if (devEmails.length === 0) {
      throw new Error('At least one development admin email is required');
    }
    if (prodEmails.length === 0) {
      throw new Error('At least one production admin email is required');
    }

    // Set global admin emails
    await setDoc(doc(db, 'admin_config', 'admin_emails'), {
      emails: globalEmails
    });
    console.log('Global admin emails initialized successfully:', globalEmails);

    // Set development admin emails
    await setDoc(doc(db, 'admin_config', 'dev_admin_emails'), {
      emails: devEmails
    });
    console.log('Development admin emails initialized successfully:', devEmails);

    // Set production admin emails
    await setDoc(doc(db, 'admin_config', 'prod_admin_emails'), {
      emails: prodEmails
    });
    console.log('Production admin emails initialized successfully:', prodEmails);

    return true;
  } catch (error: any) {
    console.error('Error initializing admin emails:', error);
    throw error;
  }
}
